// import Vue from 'vue'
import { Component, Watch } from "vue-property-decorator";
import baseUserContextPage from "../baseUserContextPage";
import axios from "axios";
import { EmployeeModel } from '@/models/employeeModels';

@Component({})
export default class employeePage extends baseUserContextPage {
  isLoading: boolean = false;
  item: EmployeeModel = new EmployeeModel();
  get id(): number {
    return this.$route && this.$route.params && this.$route.params.id
      ? Number.parseInt(this.$route.params.id)
      : null;
  }
  
  fetch(): void {
    var instance = this;
    instance.isLoading = true;

    if (instance.id != null) {
      axios
        .get<EmployeeModel>(`employee/${instance.id}`)
        .then(res => {
          instance.item = res.data ? res.data : new EmployeeModel();
          instance.isLoading = false;
        })
        .catch(error => {
          console.error(error);
          instance.isLoading = false;
        });
      }
  }
  mounted() {
    var instance = this;

    instance.fetch();
  }
}